import { registerTab } from "lib/@components/tabs"
import { PDF_HIDE_WHEN_EMPTY_TAB_PROPS } from "lib/@components/tabs/pdf-tab-content"

import { makeLazy } from "lib/make-lazy"
import { isInRegime } from "routes/facilities/lib/when-parent-item.js"

const JustificationsTab = makeLazy(() => import("./justifications-tab.js"), "JustificationsTab")

registerTab({
    tab: "ScheduleRightBar",
    id: "justifications",
    title: "Justifications",
    tabProps: PDF_HIDE_WHEN_EMPTY_TAB_PROPS,
    predicate: (context) => context.target.code.startsWith("C") && !isInRegime(context),
    content: <JustificationsTab $lazy priority={100} />,
})
